import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	modalWelcome: 2,
	dialogtwo: 3,
	dialogtwoextra: 11,
	dialogInstructionOne: 4,
	dialogInstructionTwo: 5,
	dialogInstructionThree: 6,
	activity: 7,
	activityInfo: 10,
};
export const SubtopicTwoActivityOne = () => {
	const dispatch = useDispatch();

	const navigator = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const [dityproducts, setDityproducts] = useState(0);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema2], 1);

	useEffect(() => {
		if (loaded) {
			console.log("subtema two Activity one");
			ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act1_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicTwo.activityone.findProduct, () => {
		setDityproducts(dityproducts + 1);
	});

	useEffect(() => {
		if (dityproducts >= 13) {
			ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
		}
	}, [dityproducts]);

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Limpieza en tienda." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"¡Muy bien! Estoy sorprendido con el avance que llevamos; es momento de expllicarte cómo mejorar la imagen de la tienda, te explicaré cómo a continuación"
						}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.activityInfo);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.activityInfo && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Abasto en tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogtwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogtwo && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Señala cual de las zonas requieren de atención urgente para una buena imagen de tu tienda."}
					percentage={"40%"}
					whitImg={true}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act1_a03)
						setUiToShow(steps.dialogtwoextra);
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
					}}
				></DialogBarNew>
			)}

			{uiToShow === steps.dialogtwoextra && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Encuentra y señala a los objetos que hacen que la tienda tenga una mala imagen."}
					percentage={"40%"}
					whitImg={true}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						setUiToShow(steps.modalWelcome);
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
					}}
				></DialogBarNew>
			)}

			{uiToShow === steps.modalWelcome && (
				<PanelInstrucionHands
					text="Toca y arrastra con tu dedo para girar la vista."
					action={() => {
						setUiToShow(steps.dialogInstructionOne);
					}}
					img={imgInstruction.sub2act1_01}
				/>
			)}

			{uiToShow === steps.dialogInstructionOne && (
				<PanelInstrucionHands
					text="Pellizca la pantalla para acercar o alejar la vista."
					action={() => {
						setUiToShow(steps.dialogInstructionTwo);
					}}
					img={imgInstruction.sub2act1_02}
				/>
			)}

			{uiToShow === steps.dialogInstructionTwo && (
				<PanelInstrucionHands
					text="Toca encima de los objetos para removerlos del piso."
					action={() => {
						setUiToShow(steps.activity);
						ObserverEmitter.emit(EVENTS.subtopicTwo.activityone.initInteractions);
					}}
					img={imgInstruction.sub2act1_03}
				/>
			)}

			{uiToShow === steps.activity && (
				<>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed top-0 left-40 ">
						<div className="w-16 h-8">
							<p className="bg-white">{dityproducts}/13</p>
						</div>
					</div>
				</>
			)}
			{dityproducts >= 13 && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={5}
					dialogModal="Una tienda bien aseada ayudará a que tus clientes se sientan cómodos al entrar y comprar."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 1,
								pointsWin: 5,
								subtema: tasksId.tema1.activities.subtema2,
							})
						);
						navigator("/home1/tema1/subtema2/activitytwo");
					}}
				/>
			)}
		</>
	);
};
